'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utilsLib = require('utils-lib');

var _Observer2 = require('./Observer');

var _Observer3 = _interopRequireDefault(_Observer2);

var _CustomerModel = require('./CustomerModel');

var _CustomerModel2 = _interopRequireDefault(_CustomerModel);

var _Payment = require('./Payment');

var _Payment2 = _interopRequireDefault(_Payment);

var _Contract = require('./Contract');

var _Contract2 = _interopRequireDefault(_Contract);

var _ContractConnection = require('./ContractConnection');

var _ContractConnection2 = _interopRequireDefault(_ContractConnection);

var _ContractPrice = require('./ContractPrice');

var _ContractPrice2 = _interopRequireDefault(_ContractPrice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractDetailsModel = function (_Observer) {
    _inherits(ContractDetailsModel, _Observer);

    /**
     * Folgevertragsnummer (im Falle eines Verlusts)
     * @type {string}
     */

    /**
     * Aufteilung Preis auf 2. Bezahler
     * @type {integer}
     */


    /**
     * Preis des Vertrags
     * @type {ContractPrice}
     */


    /**
     * Zahlweise für den Vertrag
     * @type {Payment}
     */
    function ContractDetailsModel(observers, id, request) {
        _classCallCheck(this, ContractDetailsModel);

        var _this = _possibleConstructorReturn(this, (ContractDetailsModel.__proto__ || Object.getPrototypeOf(ContractDetailsModel)).call(this, observers, id, request));

        _this.Contract = new _Contract2.default();

        _this.TicketCustomer = new _CustomerModel2.default();

        _this.PaymentOptionCustomer = new _Payment2.default();

        _this.ContractConnection = new _ContractConnection2.default();

        _this.ContractPrice = new _ContractPrice2.default();

        _this.Share1 = 0;
        _this.Share2 = 0;
        _this.FlagLoss = true;
        _this.FollowContractNumber = "";
        _this.DateChanged = "";
        return _this;
    }
    /**
     * Datum der letzten Änderung am Vertrag
     * @Type {date}
     */

    /**
     * Vertrag darf als "Verloren" gemeldet werden
     * @type {boolean}
     */


    /**
     * Aufteilung Preis auf 1.Bezahler
     * @type {integer}
     */


    /**
     * Streckenverbindung für den Vertrag
     * @type {ContractConnection}
     */

    /**
     * Vertragsdetails
     * @type {Contract}
     */
    /**
     * Ticketinhaber
     * @type {Customer}
     */


    _createClass(ContractDetailsModel, [{
        key: 'GetContractDetailsByContractId',
        value: function GetContractDetailsByContractId(id) {
            var me = this;
            this.request.setRequest("/contracts/" + id + "/ContractDetails");
            this.request.setType("GET");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        var result = data.Data;
                        if (result.Contract) {
                            var contract = result.Contract;
                            me.Contract.Id = contract.Id;
                            me.Contract.IdCustomer = contract.IdCustomer;
                            me.Contract.ContractNumber = contract.ContractNumber;
                            me.Contract.TicketName = contract.TicketName;
                            me.Contract.DateFrom = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(contract.DateFrom, true, localStorage.getItem('vas_language')));
                            me.Contract.DateTo = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(contract.DateTo, true, localStorage.getItem('vas_language')));
                            me.Contract.Status = contract.Status;
                            me.Contract.StatusId = contract.StatusId;
                            me.Contract.CustomerName = contract.CustomerName;
                            me.Contract.CustomerAbove = contract.CustomerAbove;
                            me.Contract.ExternalDescription = contract.ExternalDescription;
                        }

                        if (result.TicketCustomer) {
                            var ticketCustomer = result.TicketCustomer;
                            me.TicketCustomer.Id = ticketCustomer.Id;
                            me.TicketCustomer.ClientId = ticketCustomer.ClientId;
                            me.TicketCustomer.Salutation = ticketCustomer.Salutation;
                            me.TicketCustomer.Name1 = ticketCustomer.Name1;
                            me.TicketCustomer.Name2 = ticketCustomer.Name2;
                            me.TicketCustomer.Name3 = ticketCustomer.Name3;
                            me.TicketCustomer.DateOfBirth = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(ticketCustomer.DateOfBirth, true, localStorage.getItem('vas_language')));
                            me.TicketCustomer.Street = ticketCustomer.Street;
                            me.TicketCustomer.HouseNumber = ticketCustomer.HouseNumber;
                            me.TicketCustomer.HouseNumberAddition = ticketCustomer.HouseNumberAddition;
                            me.TicketCustomer.PostCode = ticketCustomer.PostCode;
                            me.TicketCustomer.City = ticketCustomer.City;
                            me.TicketCustomer.CustomerNumber = ticketCustomer.CustomerNumber;
                            me.TicketCustomer.Email = ticketCustomer.Email;
                            me.TicketCustomer.Phone = ticketCustomer.Phone;
                            me.TicketCustomer.Phone2 = ticketCustomer.Phone2;
                            me.TicketCustomer.Fax = ticketCustomer.Fax;
                            me.TicketCustomer.Gender = ticketCustomer.Gender;
                            me.TicketCustomer.Class = ticketCustomer.Class;
                            me.TicketCustomer.GradeLevel = ticketCustomer.GradeLevel;
                            me.TicketCustomer.Country = ticketCustomer.Country;
                            me.TicketCustomer.Title = ticketCustomer.Title;
                            me.TicketCustomer.RegNr = ticketCustomer.RegNr;
                            me.TicketCustomer.MarketingPost = ticketCustomer.MarketingPost;
                            me.TicketCustomer.MarketingEmail = ticketCustomer.MarketingEmail;
                            me.TicketCustomer.MarketingPhone = ticketCustomer.MarketingPhone;
                            me.TicketCustomer.FlagMarketing = ticketCustomer.FlagMarketing;
                            me.TicketCustomer.NoMail = ticketCustomer.NoMail;
                            me.TicketCustomer.CustomerCategory = ticketCustomer.CustomerCategory;
                        }

                        if (result.PaymentOptionCustomer) {
                            var PaymentOption = result.PaymentOptionCustomer;
                            me.PaymentOptionCustomer.Id = PaymentOption.Id;
                            me.PaymentOptionCustomer.BankName = PaymentOption.BankName;
                            me.PaymentOptionCustomer.Iban = PaymentOption.Iban;
                            me.PaymentOptionCustomer.Bic = PaymentOption.Bic;
                            me.PaymentOptionCustomer.AccountOwner = PaymentOption.AccountOwner;
                            me.PaymentOptionCustomer.IsDefaultPaymentMethod = PaymentOption.IsDefaultPaymentMethod;
                            me.PaymentOptionCustomer.PaymentMethod = PaymentOption.PaymentMethod;
                            me.PaymentOptionCustomer.PaymentMethodValue = PaymentOption.PaymentMethodValue;
                            me.PaymentOptionCustomer.ValidFrom = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(PaymentOption.ValidFrom, true, localStorage.getItem('vas_language')));
                            me.PaymentOptionCustomer.ValidTo = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(PaymentOption.ValidTo, true, localStorage.getItem('vas_language')));
                        }

                        if (result.ContractConnection) {
                            var Connection = result.ContractConnection;
                            me.ContractConnection.From = Connection.From;
                            me.ContractConnection.To = Connection.To;
                            me.ContractConnection.Via = Connection.Via;
                            me.ContractConnection.StopFrom = Connection.StopFrom;
                            me.ContractConnection.StopTo = Connection.StopTo;
                        }

                        if (result.ContractPrice) {
                            var Price = result.ContractPrice;
                            me.ContractPrice.PriceLevel = Price.PriceLevel;
                            me.ContractPrice.Price = Price.Price;
                        }

                        if (result.Share1) {
                            me.Share1 = result.Share1;
                        }

                        if (result.Share2) {
                            me.Share2 = result.Share2;
                        }

                        if (result.FlagLoss !== null && result.FlagLoss !== undefined) {
                            me.FlagLoss = result.FlagLoss;
                        }

                        if (result.FollowContractNumber) {
                            me.FollowContractNumber = result.FollowContractNumber;
                        }

                        if (result.DateChanged) {
                            me.DateChanged = result.DateChanged;
                        }
                    }
                }
                var id = me.Id ? me.Id : "ContractDetails";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return ContractDetailsModel;
}(_Observer3.default);

exports.default = ContractDetailsModel;